import { render } from "./PencilIcon.vue?vue&type=template&id=53ed9b03"
import script from "./PencilIcon.vue?vue&type=script&lang=js"
export * from "./PencilIcon.vue?vue&type=script&lang=js"
script.render = render

export default script